import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";

import { Config } from "@/utils/config.utils";
import { CheckoutSteps } from "@/utils/enums";

import { CartModel } from "./@types/cart.model";
import { CheckoutStepValidationResult } from "./@types/cart.types";

const ChronologicalCheckoutSteps = [
    CheckoutSteps.login,
    CheckoutSteps.account,
    CheckoutSteps.payment,
    CheckoutSteps.confirmation
];

export const recalculateRemovableQuantity = (
    cart: CartModel | null,
    id: string,
    quantityToRemove: number
) => {
    if (!cart) {
        return quantityToRemove;
    }
    const simularItems = cart.items.filter((i) => i.id === id);
    if (simularItems.length < 2) {
        return quantityToRemove;
    }

    const hasFreeAndFreeAddedByCustomerItem = simularItems.find(
        (i) => i.free && i.freeEntryAddedByCustomer
    );
    if (
        hasFreeAndFreeAddedByCustomerItem &&
        hasFreeAndFreeAddedByCustomerItem.deliveryType ===
            DeliveryType.HomeDelivery &&
        (hasFreeAndFreeAddedByCustomerItem.minimumOrderQuantity || 0) > 0
    ) {
        return simularItems.reduce((acc, curr) => {
            acc = acc + curr.quantity;
            return acc;
        }, 0);
    }

    return quantityToRemove;
};

// Check if the current step is valid and redirect otherwise
// -> To 'shoppingCart' if the cart is empty or not found
// -> To 'cart.checkoutStep' if the user is at the incorrect checkout step
export const validateAndRedirect =
    (componentCheckoutStep: CheckoutSteps) =>
    (cart: CartModel | undefined | null) => {
        if (Config.isDevelopment()) {
            return CheckoutStepValidationResult.Valid;
        }

        if (cart === null) {
            return CheckoutStepValidationResult.Valid;
        }

        if (!isDefined(cart) || isEmpty(cart.items)) {
            location.assign(Config.pages.cart);

            return CheckoutStepValidationResult.RedirectToCart;
        }

        const cartCheckoutStepOrder = ChronologicalCheckoutSteps.indexOf(
            cart.checkoutStep
        );
        const componentCheckoutStepOrder = ChronologicalCheckoutSteps.indexOf(
            componentCheckoutStep
        );

        if (componentCheckoutStepOrder > cartCheckoutStepOrder) {
            location.assign(Config.pages[`checkout-${cart.checkoutStep}`]);

            return CheckoutStepValidationResult.RedirectToStep;
        }

        return CheckoutStepValidationResult.Valid;
    };
